import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'shared/button/button.module';
import { ContextualActionsModule } from 'shared/contextual-actions/contextual-actions.module';
import { FitmentsContextualActionComponent } from './contextual-action.component';
import { ResearchActionComponent } from './research-action.component';
import { LoadedProductActionComponent } from './loaded-product-action.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    ContextualActionsModule,
  ],
  declarations: [
    FitmentsContextualActionComponent,
    ResearchActionComponent,
    LoadedProductActionComponent,
  ],
  exports: [
    FitmentsContextualActionComponent,
    ResearchActionComponent,
    LoadedProductActionComponent,
  ],
  providers: []
})
export class FitmentsContextualActionModule {}
